import styled from 'styled-components';

export const DiscussionContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 10px;
  @media (min-width: 720px) {
    width: 80%;
    margin: auto;
  }
  h2 {
    position: relative;
    font-size: clamp(16px, 2vw, 20px);
    font-weight: bold;
    text-transform: capitalize;
  }
  h3 {
    color: rgba(0, 0, 0, 0.8);
    position: relative;
    font-size: clamp(12px, 2vw, 18px);
    font-weight: 500;
    text-transform: capitalize;
  }
  .headings {
    border-bottom: 1px solid #00000045;
    border-spacing: 5px;
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    padding-bottom: 12px;
  }
  .questionCover {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    padding-bottom: 10px;
    .question {
      font-size: clamp(13px, 2vw, 18px);
      font-weight: bold;
    }
    .answer {
      font-size: clamp(12px, 2vw, 16px);
      font-weight: 500;
    }
    border-bottom: 1px solid #00000045;
    outline-offset: 3px;
  }
  .viewAll {
    font-size: clamp(12px, 2vw, 16px);
    color: #ef4e5e;
    outline: none;
    border: none;
    background: none;
    font-weight: bold;
    display: flex;
  }
  .seeMore {
    color: #534545a8;
  }
`;
